import React, { useState } from 'react';

// Shared editor: a lesson (materia + one lesson per line) or a single evaluation note
export const LessonForm = ({ initial = {}, noteOnly, onSave, onCancel, testid }) => {
  const [materia, setMateria] = useState(initial.materia || '');
  const [text, setText] = useState(noteOnly ? initial.note || '' : (initial.lecciones || []).join('\n'));
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try { await onSave(noteOnly ? { note: text } : { materia, lecciones: text.split('\n').map((l) => l.trim()).filter(Boolean) }); } finally { setSaving(false); }
  };
  const box = 'w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-200 focus:border-amber-500/60 focus:outline-none';
  return (
    <div data-testid={testid} className="space-y-2">
      {!noteOnly && <input data-testid={`${testid}-materia`} value={materia} onChange={(e) => setMateria(e.target.value)} placeholder="Materia (ej. Arrendamiento · restitución anticipada)" className={box} />}
      <textarea data-testid={`${testid}-text`} value={text} onChange={(e) => setText(e.target.value)} rows={noteOnly ? 2 : 4}
        placeholder={noteOnly ? 'Qué debe corregir Fidem' : 'Una lección por línea: qué debe hacer o evitar Fidem'} className={box} />
      <div className="flex gap-2">
        <button data-testid={`${testid}-save`} disabled={saving || !text.trim()} onClick={save} className="rounded-lg bg-amber-500 px-3 py-1.5 text-xs font-semibold text-slate-950 transition-opacity hover:opacity-90 disabled:opacity-40">{saving ? 'Guardando…' : 'Guardar'}</button>
        {onCancel && <button data-testid={`${testid}-cancel`} onClick={onCancel} className="rounded-lg px-3 py-1.5 text-xs text-slate-400 hover:text-white">Cancelar</button>}
      </div>
    </div>
  );
};
